import React from "react";
import { Gamepad2, Users, Crosshair, MessageSquare, Image, Star } from "lucide-react";
import { AdminDashboardCard } from "./AdminDashboardCard";

export const AdminDashboardContent: React.FC = () => {
  const cardData = [
    {
      title: "Gerenciar Jogos",
      description: "Adicione, edite ou remova jogos da plataforma",
      icon: <Gamepad2 className="h-8 w-8" />,
      linkUrl: "/painel-admin/jogos",
      linkText: "Ver Jogos"
    },
    {
      title: "Gerenciar Usuários",
      description: "Visualize e gerencie todos os usuários da plataforma",
      icon: <Users className="h-8 w-8" />,
      linkUrl: "/painel-admin/usuarios",
      linkText: "Ver Usuários"
    },
    {
      title: "Gerenciar Mentorias",
      description: "Monitore as mentorias ativas e agendadas",
      icon: <Crosshair className="h-8 w-8" />,
      linkUrl: "/painel-admin/mentorias",
      linkText: "Ver Mentorias"
    },
    {
      title: "Gerenciar Depoimentos",
      description: "Adicione, edite ou remova depoimentos da página inicial",
      icon: <MessageSquare className="h-8 w-8" />,
      linkUrl: "/painel-admin/depoimentos",
      linkText: "Ver Depoimentos"
    },
    {
      title: "Configurações do Hero",
      description: "Configure a imagem de fundo e transparência da seção principal",
      icon: <Image className="h-8 w-8" />,
      linkUrl: "/painel-admin/hero",
      linkText: "Configurar Hero"
    },
    {
      title: "Gerenciar Destaques",
      description: "Configure quais mentorias, mentores e comunidades aparecem em destaque",
      icon: <Star className="h-8 w-8" />,
      linkUrl: "/painel-admin/destaques",
      linkText: "Ver Destaques"
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {cardData.map((card, index) => (
        <AdminDashboardCard
          key={index}
          title={card.title}
          description={card.description}
          icon={card.icon}
          linkUrl={card.linkUrl}
          linkText={card.linkText}
        />
      ))}
    </div>
  );
};
